import { useEffect } from 'react';
import { useWidget } from '@telescope/cassini-hooks';
import { Flex, VStack, useBreakpointValue } from '@telescope/cassini-ui';
import { isIframed, loadWidgetFonts, APP_MAX_WIDTH } from 'utils';
import { Header, Footer, AuthNav, GeoBlocking } from 'features';
import { Outlet } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';
import { Campaign } from 'types';
import { AbbreviatedRules } from './AbbreviatedRules';
import { RulesButton } from './RulesButton';
import { AdUnit, AdUnitSize, FallbackError } from 'components';

const isAppIframed = isIframed();

export const AppShell = () => {
  const { data: widgetData } = useWidget({ select: (data: Campaign) => data.widget });
  const { fonts: accountFonts, global_views, ads, campaignFonts: { fonts: { font_settings } } } = widgetData!;
  // TODO: udpate CLI to add types inserted by campaign api:
  // [k: string]: unknown; url?: string | undefined;
  const fontSettings = font_settings as any;
  const { sitewide } = global_views;

  const adSize: AdUnitSize = useBreakpointValue({ base: 'mobileLeaderboard', md: 'leaderboard' })!;
  const footerAd = ads.footer[adSize];

  useEffect(() => {
    loadWidgetFonts([ ...accountFonts, ...fontSettings ]);
  }, [accountFonts, font_settings]);

  return (
    <Flex direction="column" minH={isAppIframed ? 'auto' : '100vh'} alignItems="center" {...sitewide.styles.app}>
      <GeoBlocking>

        <Header />

        <Flex as="main" flex={isAppIframed ? 0 : 1} flexGrow="2" p={[ 2, 2, 8 ]} w="100%" justifyContent="flex-start" direction="column"
              maxW={{ base: APP_MAX_WIDTH.MOBILE, md: APP_MAX_WIDTH.TABLET, lg: APP_MAX_WIDTH.DESKTOP }}>
          <ErrorBoundary FallbackComponent={FallbackError}>
            <AuthNav />
            <Outlet />
            <RulesButton />
            <AbbreviatedRules />
          </ErrorBoundary>
        </Flex>

        <AdUnit size={adSize} alignSelf="center" mb={[5, 8]} {...footerAd}></AdUnit>
        <Footer />
        
      </GeoBlocking>
    </Flex>
  )
}